import tag from 'blacklist-tag';
import { Form } from 'formik';
import * as React from 'react';
import styled from 'styled-components';
import { alignItems, borderRadius, color, flex, flexDirection, flexWrap, height, space, width } from 'styled-system';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';

interface Props extends StyledSystemProps {
  bg?: string;
  type?: string;
  name?: string;
  width?: string;
  color?: string;
  height?: string;
  placeholder?: string;
  children: React.ReactNode;
  borderRadius?: string | number;
}

const CleanForm = tag(Form as any, [
  'justifyContent',
  'alignItems',
  'maxWidth',
  'renderTabs',
  'flexDirection',
  'flexWrap',
]);

const StyledForm = styled(CleanForm)`
  ${flex};
  ${space};
  ${width};
  ${color};
  ${height};
  ${flexWrap};
  ${alignItems};
  ${borderRadius};
  ${flexDirection};
  display: flex;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: ${(props: Props) => (props.bg === 'transparent' ? 'none' : '0 0px 4px -1px rgba(50,50,93,0.3)')};
`;

export default StyledForm;

StyledForm.defaultProps = {
  width: '100%',
  height: 'auto',
  bg: 'transparent',
  flexDirection: 'column',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
};
